import { api } from './client';
import type { CallLogEntrySummary } from './types';

/**
 * A "matched neighbour": someone the member has been matched or committed
 * with, or already has a direct conversation with (GET /neighbors;
 * mobile/src/services/neighborsApi.ts). Public view only (FR-050).
 */
export interface Neighbor {
  id: string;
  name: string;
  accountType?: string;
  trustScore?: number;
  identityVerificationStatus?: string;
  skills?: string[];
  photoUrl?: string;
  /** The existing direct or broadcast conversation with this neighbour, if any. */
  conversationId: string | null;
  /** The most recent commitment shared with this neighbour, if any. */
  commitmentId: string | null;
}

export const neighborsApi = {
  list: () => api.get<Neighbor[]>('/neighbors'),
};

/** The member's call history (GET /calls/log); User Story 4 adds the rest of the calling API. */
export const callLogApi = {
  list: () => api.get<CallLogEntrySummary[]>('/calls/log'),
};
